import {
  SET_SEATMAP,
  SELECT_SEAT,
  SET_ACTIVE_SEGMENT,
  UNSELECT_SEAT,
  SELECT_SEAT_REBOOK,
  UNSELECT_SEAT_REBOOK,
  CLEAR_SEAT_SELECTED,
  SELECT_SEAT_EVENTS,
  UNSELECT_SEAT_EVENTS,
} from '../actions/seat';
// eslint-disable-next-line import/no-named-as-default
import produce from 'immer';

const initialState = {
  seatMaps: undefined,
  seatSelection: {},
  activeSegmentId: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SEATMAP:
      return {
        ...state,
        seatMaps: {
          ...state.seatMaps,
          [action.airSegmentId]: action.seatMap,
        },
      };
    case SELECT_SEAT: {
      const { airSegmentId, passengerIndex, seat, classOfService } = action;
      const oldSelectedSeat =
        state.seatSelection[airSegmentId] && state.seatSelection[airSegmentId][passengerIndex];
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: {
            ...state.seatSelection[airSegmentId],
            [passengerIndex]: {
              ...seat,
              classOfService,
            },
          },
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap.Rows[seat.row - seatMap.StartRowNumber]?.Seats.find(
              (x) => x.SeatNumber === seat.SeatNumber
            );
            if (newSelected) {
              newSelected.selected = true;
            }

            if (oldSelectedSeat) {
              const oldSeatMap = seatObject.ClassesOfService[oldSelectedSeat.classOfService];
              const oldSelected = oldSeatMap.Rows[
                oldSelectedSeat.row - oldSeatMap.StartRowNumber
              ]?.Seats.find((x) => x.SeatNumber === oldSelectedSeat.SeatNumber);
              if (oldSelected) {
                oldSelected.selected = false;
              }
            }
          }),
        },
      };
    }
    case SELECT_SEAT_REBOOK: {
      const { airSegmentId, passengerName, seat, classOfService } = action;
      const oldSelectedSeat =
        state.seatSelection[airSegmentId] && state.seatSelection[airSegmentId][passengerName];
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: {
            ...state.seatSelection[airSegmentId],
            [passengerName]: {
              ...seat,
              classOfService,
            },
          },
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap.Rows[seat.row - seatMap.StartRowNumber]?.Seats.find(
              (x) => x.SeatNumber === seat.SeatNumber
            );
            if (newSelected) {
              newSelected.selected = true;
            }

            if (oldSelectedSeat) {
              const oldSeatMap = seatObject.ClassesOfService[oldSelectedSeat.classOfService];
              const oldSelected = oldSeatMap.Rows[
                oldSelectedSeat.row - oldSeatMap.StartRowNumber
              ]?.Seats.find((x) => x.SeatNumber === oldSelectedSeat.SeatNumber);
              if (oldSelected) {
                oldSelected.selected = true;
              }
            }
          }),
        },
      };
    }
    case SELECT_SEAT_EVENTS: {
      const { airSegmentId, passengerName, seat, classOfService } = action;
      const oldSelectedSeat =
        state.seatSelection[airSegmentId] && state.seatSelection[airSegmentId][passengerName];
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: {
            ...state.seatSelection[airSegmentId],
            [passengerName]: {
              ...seat,
              classOfService,
            },
          },
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap.Rows[seat.row - seatMap.StartRowNumber]?.Seats.find(
              (x) => x.SeatNumber === seat.SeatNumber
            );
            if (newSelected) {
              newSelected.selected = true;
            }

            if (oldSelectedSeat) {
              const oldSeatMap = seatObject.ClassesOfService[oldSelectedSeat.classOfService];
              const oldSelected = oldSeatMap.Rows[
                oldSelectedSeat.row - oldSeatMap.StartRowNumber
              ]?.Seats.find((x) => x.SeatNumber === oldSelectedSeat.SeatNumber);
              if (oldSelected) {
                oldSelected.selected = true;
              }
            }
          }),
        },
      };
    }

    case UNSELECT_SEAT: {
      const { airSegmentId, passengerIndex, seat, classOfService } = action;
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: produce(state.seatSelection[airSegmentId], (seatSelection) => {
            delete seatSelection[passengerIndex];
          }),
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap?.Rows[seat.row - seatMap.StartRowNumber]?.Seats?.find(
              (x) => x?.SeatNumber === seat?.SeatNumber
            );
            if (newSelected) {
              newSelected.selected = false;
            }
          }),
        },
      };
    }
    case UNSELECT_SEAT_REBOOK: {
      const { airSegmentId, passengerName, seat, classOfService } = action;
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: produce(state.seatSelection[airSegmentId], (seatSelection) => {
            delete seatSelection[passengerName];
          }),
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap.Rows[seat.row - seatMap.StartRowNumber]?.Seats.find(
              (x) => x.SeatNumber === seat.SeatNumber
            );
            newSelected.selected = false;
          }),
        },
      };
    }
    case UNSELECT_SEAT_EVENTS: {
      const { airSegmentId, passengerName, seat, classOfService } = action;
      return {
        ...state,
        seatSelection: {
          ...state.seatSelection,
          [airSegmentId]: produce(state.seatSelection[airSegmentId], (seatSelection) => {
            delete seatSelection[passengerName];
          }),
        },
        seatMaps: {
          ...state.seatMaps,
          [airSegmentId]: produce(state.seatMaps[airSegmentId], (seatObject) => {
            const seatMap = seatObject.ClassesOfService[classOfService];
            const newSelected = seatMap.Rows[seat.row - seatMap.StartRowNumber]?.Seats.find(
              (x) => x.SeatNumber === seat.SeatNumber
            );
            newSelected.selected = false;
          }),
        },
      };
    }

    case SET_ACTIVE_SEGMENT:
      return {
        ...state,
        activeSegmentId: action.segmentId,
      };
    case CLEAR_SEAT_SELECTED:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
